import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgAddOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "add-outline" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created using Figma" }),
		/* @__PURE__ */ _jsx("g", {
			id: "Canvas",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "add-outline",
				children: [/* @__PURE__ */ _jsxs("g", {
					id: "add-outline__border",
					children: [
						/* @__PURE__ */ _jsx("use", {
							xlinkHref: "#path0_fill",
							transform: "translate(0 -5.68434e-14)",
							fill: "#FFFFFF"
						}),
						/* @__PURE__ */ _jsx("mask", {
							id: "mask0_outline_ins",
							children: /* @__PURE__ */ _jsx("use", {
								xlinkHref: "#path0_fill",
								fill: "white",
								transform: "translate(0 -5.68434e-14)"
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							mask: "url(#mask0_outline_ins)",
							children: /* @__PURE__ */ _jsx("use", {
								xlinkHref: "#path1_stroke_2x",
								transform: "translate(0 -5.68434e-14)",
								fill: "#C2CDD7"
							})
						})
					]
				}), /* @__PURE__ */ _jsx("g", {
					id: "add-outline__text",
					children: /* @__PURE__ */ _jsx("use", {
						xlinkHref: "#path2_fill",
						transform: "translate(10 6)",
						fill: "#4384F5"
					})
				})]
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("path", {
				id: "path0_fill",
				d: "M 0 4C 0 1.79086 1.79086 0 4 0L 24 0C 26.2091 0 28 1.79086 28 4L 28 24C 28 26.2091 26.2091 28 24 28L 4 28C 1.79086 28 0 26.2091 0 24L 0 4Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "path1_stroke_2x",
				d: "M 4 1L 24 1L 24 -1L 4 -1L 4 1ZM 27 4L 27 24L 29 24L 29 4L 27 4ZM 24 27L 4 27L 4 29L 24 29L 24 27ZM 1 24L 1 4L -1 4L -1 24L 1 24ZM 4 27C 2.34315 27 1 25.6569 1 24L -1 24C -1 26.7614 1.23858 29 4 29L 4 27ZM 27 24C 27 25.6569 25.6569 27 24 27L 24 29C 26.7614 29 29 26.7614 29 24L 27 24ZM 24 1C 25.6569 1 27 2.34315 27 4L 29 4C 29 1.23858 26.7614 -1 24 -1L 24 1ZM 4 -1C 1.23858 -1 -1 1.23858 -1 4L 1 4C 1 2.34315 2.34315 1 4 1L 4 -1Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "path2_fill",
				d: "M 4.58008 7.66113L 7.35547 7.66113L 7.35547 8.85742L 4.58008 8.85742L 4.58008 12.002L 3.30859 12.002L 3.30859 8.85742L 0.533203 8.85742L 0.533203 7.66113L 3.30859 7.66113L 3.30859 4.75586L 4.58008 4.75586L 4.58008 7.66113Z"
			})
		] })
	]
});
export default SvgAddOutline;
